import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  proceed(event) {
    event.preventDefault();

    const checked = this.element.querySelector('input[type="radio"]:checked');
    if (checked) {
      window.location.href = checked.value;
    }
  }
}
